import { useEffect, useRef } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Sidebar }              from '@/components/layout/Sidebar'
import { MobileHeader }          from '@/components/layout/MobileHeader'
import { BottomNav }             from '@/components/layout/BottomNav'
import { SignalRProvider }       from '@/providers/SignalRProvider'
import { MobileSidebarProvider } from '@/providers/MobileSidebarProvider'
import { SessionGuard }          from '@/auth/SessionGuard'
import { InactivityWatcher }     from '@/auth/InactivityWatcher'

export function AppLayout() {
  const mainRef = useRef<HTMLElement>(null)
  const { pathname } = useLocation()

  useEffect(() => {
    mainRef.current?.scrollTo({ top: 0 })
  }, [pathname])

  return (
    <SignalRProvider>
        <MobileSidebarProvider>
          <InactivityWatcher />
          <div className="flex h-screen overflow-hidden bg-[var(--color-background)]">
            <Sidebar />
            <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
              <MobileHeader />
              <main ref={mainRef} className="flex-1 overflow-y-auto pb-16 lg:pb-0">
                <SessionGuard>
                  {/* Single source of truth for content width.
                      700px max on desktop, full-width on mobile. */}
                  <div className="min-h-full flex flex-col w-full lg:max-w-[700px] lg:mx-auto">
                    <Outlet />
                  </div>
                </SessionGuard>
              </main>
            </div>
            <BottomNav />
          </div>
        </MobileSidebarProvider>
    </SignalRProvider>
  )
}
